// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"jn_a bht_rm","PhotoTitleEditForm__cancelBtn":"jn_b bht_rq bht_rp"};